import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss']
})
export class CustomLoaderComponent implements OnInit, OnDestroy {
  @Input() isVisible: boolean = false;
  @Input() loadingText: string = 'Loading...';
  @Input() showLogo: boolean = true;
  @Input() showProgress: boolean = true;

  loadingDots: string = '';
  private animationInterval: any;
  private subscription: Subscription = new Subscription();

  ngOnInit(): void {
    this.startLoadingAnimation();
  }

  ngOnDestroy(): void {
    this.clearLoadingAnimation();
    this.subscription.unsubscribe();
  }

  private startLoadingAnimation(): void {
    let dotCount = 0;
    this.animationInterval = setInterval(() => {
      dotCount = (dotCount + 1) % 4;
      this.loadingDots = '.'.repeat(dotCount);
    }, 500);
  }

  private clearLoadingAnimation(): void {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  }
}
